export default "__VITE_ASSET__BlU0Bwei__"